<template>
<div>
  <footer class="hidden">
    <div class="footer">
      <div class="footer--link">
        <ul class="footer--link-ul animation-left">
          <li>
            <router-link :to="{ name: '' }">Sobre</router-link>
          </li>
          <li>
            <router-link :to="{ name: '' }">Escolas</router-link>
          </li>
          <li>
            <router-link :to="{ name: '' }">A Minds</router-link>
          </li>
          <li>
            <router-link :to="{ name: '' }">Ajuda</router-link>
          </li>
          <li>
            <router-link :to="{ name: '' }">Normas</router-link>
          </li>
          <li>
            <router-link :to="{ name: '' }">Politica de privacidade</router-link>
          </li>
        </ul>
      </div>
      <div class="footer--rights animation-right">
        © {{ year }} Minds, Inc. Todos os direitos reservados.
      </div>
    </div>
  </footer>
</div>
</template>

<script type="text/javascript">
  export default {
    computed: {
      year () {
        const today = new Date()

        return today.getUTCFullYear()
      }
    }
  }
</script>

<style lang="scss" scoped>
footer {
    background-image: linear-gradient(-180deg, #C50737 60%, #CD1F26);
}
.footer {
    width: 980px;
    max-width: 100%;
    margin: 0 auto;
    min-height: 150px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #FF9AA6;
    padding-top: 20px;
    padding-bottom: 20px;
    box-sizing: border-box;
    font-size: 14px;
    a,
    router-link {
        color: #FF9AA6;
        font-weight: bold;
        transition: 0.1s;
        font-size: 14px;
        &:hover {
            color: #fff;
        }
    }
    .footer--link {
        .footer--link-ul {
            list-style: none;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            justify-content: flex-start;
            li {
                margin-right: 10px;
                margin-top: 3px;
                margin-bottom: 3px;
            }
        }
    }
    .footer--rights {
        text-align: right;
    }
}
@media screen and (max-width: 980px) {
    .footer--link {
        margin-left: 20px;
    }
    .footer--rights {
        margin-right: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue